// import category from "../pages/category/[categoryName]/CategoryMainPage.tsx";
// import frontPage from "../pages/front-page.tsx";
// import article from "../pages/[article].tsx";

export default {
  // category: category,
  // "front-page": frontPage,
  // single: article,
};
